export default __webpack_public_path__ + "static/trophy-illus-2-218ea2c032b876e3b13d806daa4050fc.svg";